// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Cloud Costs API
 * API to get cloud cost information about Aura components and dev environments. Is used by the Aura Portal.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApitypesTotalPerDay } from './ApitypesTotalPerDay';
import {
  ApitypesTotalPerDayFromJSON,
  ApitypesTotalPerDayFromJSONTyped,
  ApitypesTotalPerDayToJSON,
  ApitypesTotalPerDayToJSONTyped,
} from './ApitypesTotalPerDay';
import type { ApitypesServiceCost } from './ApitypesServiceCost';
import {
  ApitypesServiceCostFromJSON,
  ApitypesServiceCostFromJSONTyped,
  ApitypesServiceCostToJSON,
  ApitypesServiceCostToJSONTyped,
} from './ApitypesServiceCost';

/**
 *
 * @export
 * @interface ApitypesEnvironmentCosts
 */
export interface ApitypesEnvironmentCosts {
  /**
   *
   * @type {number}
   * @memberof ApitypesEnvironmentCosts
   */
  averageCostPerDay?: number;
  /**
   *
   * @type {string}
   * @memberof ApitypesEnvironmentCosts
   */
  environmentID?: string;
  /**
   *
   * @type {string}
   * @memberof ApitypesEnvironmentCosts
   */
  environmentName?: string;
  /**
   *
   * @type {number}
   * @memberof ApitypesEnvironmentCosts
   */
  maxCostPerDay?: number;
  /**
   *
   * @type {number}
   * @memberof ApitypesEnvironmentCosts
   */
  minCostPerDay?: number;
  /**
   *
   * @type {Array<ApitypesServiceCost>}
   * @memberof ApitypesEnvironmentCosts
   */
  serviceCosts?: Array<ApitypesServiceCost>;
  /**
   *
   * @type {Array<ApitypesTotalPerDay>}
   * @memberof ApitypesEnvironmentCosts
   */
  totalsPerDay?: Array<ApitypesTotalPerDay>;
}

/**
 * Check if a given object implements the ApitypesEnvironmentCosts interface.
 */
export function instanceOfApitypesEnvironmentCosts(
  value: object,
): value is ApitypesEnvironmentCosts {
  return true;
}

export function ApitypesEnvironmentCostsFromJSON(
  json: any,
): ApitypesEnvironmentCosts {
  return ApitypesEnvironmentCostsFromJSONTyped(json, false);
}

export function ApitypesEnvironmentCostsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApitypesEnvironmentCosts {
  if (json == null) {
    return json;
  }
  return {
    averageCostPerDay:
      json['averageCostPerDay'] == null ? undefined : json['averageCostPerDay'],
    environmentID:
      json['environmentID'] == null ? undefined : json['environmentID'],
    environmentName:
      json['environmentName'] == null ? undefined : json['environmentName'],
    maxCostPerDay:
      json['maxCostPerDay'] == null ? undefined : json['maxCostPerDay'],
    minCostPerDay:
      json['minCostPerDay'] == null ? undefined : json['minCostPerDay'],
    serviceCosts:
      json['serviceCosts'] == null
        ? undefined
        : (json['serviceCosts'] as Array<any>).map(ApitypesServiceCostFromJSON),
    totalsPerDay:
      json['totalsPerDay'] == null
        ? undefined
        : (json['totalsPerDay'] as Array<any>).map(ApitypesTotalPerDayFromJSON),
  };
}

export function ApitypesEnvironmentCostsToJSON(
  json: any,
): ApitypesEnvironmentCosts {
  return ApitypesEnvironmentCostsToJSONTyped(json, false);
}

export function ApitypesEnvironmentCostsToJSONTyped(
  value?: ApitypesEnvironmentCosts | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    averageCostPerDay: value['averageCostPerDay'],
    environmentID: value['environmentID'],
    environmentName: value['environmentName'],
    maxCostPerDay: value['maxCostPerDay'],
    minCostPerDay: value['minCostPerDay'],
    serviceCosts:
      value['serviceCosts'] == null
        ? undefined
        : (value['serviceCosts'] as Array<any>).map(ApitypesServiceCostToJSON),
    totalsPerDay:
      value['totalsPerDay'] == null
        ? undefined
        : (value['totalsPerDay'] as Array<any>).map(ApitypesTotalPerDayToJSON),
  };
}
